<template>
	<Sidebar
		v-model:visible="showPanel"
		:position="props.position"
		:modal="props.modal"
		:class="sidebarClassList"
		:dismissable="props.dismissable"
		:blockScroll="true"
	>
		<template #container="{ closeCallback }">
			<div v-if="props.headerStyle != 'author' && props.headerStyle != 'complaince'  && props.headerStyle != 'report' && props.headerStyle != 'callAssistantModal'" class="p-3" :class="headerClass">
				<div class="flex items-center">
					<div class="flex-grow flex items-center gap-2">
						<div class="">
							<EwIcon :icon="props.icon" class="w-5 h-5" />
						</div>
						<div class="text-md font-medium" v-tooltip.bottom="props.title">{{ props.title }}</div>
					</div>
					<EwIcon icon="tabler:x" class="cursor-pointer w-5 h-5" @click="handleClose(closeCallback)" />
				</div>
				<div>{{ props.description }}</div>
			</div>
			<slot name="sidepanelnav" />
			<div class="flex-grow overflow-y-hidden" :class="{ 'p-0': !props.empty && !props.compactContent }">
				<slot />
			</div>
			<div class="p-2 flex bg-dark" v-if="props.headerStyle === 'print' || props.headerStyle === 'slideshow' || props.headerStyle === 'feedback' || 
			 !['report', 'callAssistantModal', 'complaince', 'author', 'dark', 'lngReviewEdit', 'notification', 'slideshowEdit'].includes(props.headerStyle)">
				<slot name="footer" :close="closeCallback">
					<div v-if="$slots.footerleft">
						<slot name="footerleft" />
					</div>
					<div class="flex ml-auto gap-2">
						<EwButton :size="'sm'" type="secondary" label="Close" @click="closeCallback" />
					</div>
				</slot>
			</div>
		</template>
	</Sidebar>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { useEventBus } from '@vueuse/core'

import Sidebar from 'primevue/sidebar'
import { sidebarPanelProps, type SidebarPanelEmits } from './meta'

// Props dhe emits
const props = defineProps(sidebarPanelProps)
const emit = defineEmits<SidebarPanelEmits>()

// EventBus për rifreskim
const refreshListEvent = useEventBus('refresh-listview')

// Computed për panelin
const showPanel = computed({
	get: () => props.visible,
	set: (value) => emit('update:visible', value),
})

// Klasat e sidebarit sipas madhësisë
const sidebarClassList = computed(() => {
	const sidebarClassList = ['w-full']
	switch (props.size) {
		case 'sm':
			sidebarClassList.push('md:w-15rem')
			break
		case 'md':
			sidebarClassList.push('md:w-25rem')
			break
		case 'lg':
			sidebarClassList.push('md:w-45rem')
			break
		case 'xl':
			sidebarClassList.push('md:w-55rem')
			break
		case 'xxl':
			sidebarClassList.push('md:w-75rem')
			break
		case 'full':
			sidebarClassList.push('md:w-full')
			break
		case 'lngReviewEdit':
			sidebarClassList.push('md:w-full')
			break
		default:
			sidebarClassList.push(props.size)
			break
	}
	return sidebarClassList
})

// Header style
const headerClass = computed(() => {
	switch (props.headerStyle) {
		case 'brand':
		case 'dark':
		case 'author':
			return 'bg-dark text-white'
		default:
			return 'bg-dark text-white'
	}
})

// Mesazhet nga iframe për mbyllje
function handleMessage(event: MessageEvent) {
	// Filtro të gjithë mesazhet që nuk janë të tuat
	if (!event.data || typeof event.data !== 'object' || !('action' in event.data)) return


	if (event.data.action === 'close-and-refresh') {
		showPanel.value = false
		refreshListEvent.emit()
	}
}
// === NEW: handle manual close nga ikona "x"
function handleClose(closeCallback: () => void) {
  closeCallback()
  refreshListEvent.emit() // kjo do bëjë refresh në ListView.vue
}
watch(showPanel, (isOpen) => {
    if (isOpen) {
        window.dispatchEvent(new CustomEvent("GLOBAL_STOP_AUDIO"))
    }
})

onMounted(() => {
	window.addEventListener('message', handleMessage)
	window.dispatchEvent(new CustomEvent("GLOBAL_STOP_AUDIO"))

})

onBeforeUnmount(() => {
	window.removeEventListener('message', handleMessage)
})
</script>
